import { buildModel } from '../common/model';

const HIDE_DIMENSIONS = [
  'filters', 'tags', 'local_time', 'text_data',
  'window_title', 'logon_event', 'install_event', 'children_count',
  'parent_id', 'id', 'filters_data',
];

const CUBE_INDEX = 0;

export class CurrentModelService {
  constructor(Models, $q) {
    this.Models = Models;
    this.$q = $q;
    this.loading = false;
  }

  load() {
    return this.$q.resolve()
      .then(() => {
        this.loading = true;
        return this.Models.load();
      })
      .then(model => {
        model = buildModel(model);
        model._dimensions = model.dimensions;
        HIDE_DIMENSIONS.forEach(key => {
          model.dimensions = model.dimensions.filter(dim => key !== dim.name);
          model.cubes[CUBE_INDEX].dimensions =
            model.cubes[CUBE_INDEX].dimensions.filter(dim => key !== dim.name);
        });
        // Sort time dimensions
        if (model.dimensions && model.dimensions.length) {
          model.dimensions = model.dimensions.filter(d => {
            if (d.name === 'agent_time') {
              d.hierarchies = d.hierarchies.filter(h => h.name !== 'ymdhq');
              // modify?
              d.hierarchies.sort();
              return true;
            } else {
              return true;
            }
          });
        }
        this.model = model;
        this.cube = model.cubes[CUBE_INDEX];
      })
      .finally(() => {
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/current-model.service.js